import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { Batch } from '@paragon/contract-library';

import { productionGroupDeleted } from './productionGroupsSlice';

export interface BatchesState {
  [batchGuid: string]: Batch;
}

const initialState: BatchesState = {};

const batchesSlice = createSlice({
  name: 'batches',
  initialState,
  reducers: {
    batchesLoaded: (state, action: PayloadAction<readonly Batch[]>) => {
      for (const batch of action.payload) {
        state[batch.guid] = castDraft(batch);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(productionGroupDeleted, (state, action) => {
      for (const [batchGuid, batch] of Object.entries(state)) {
        if (batch.productionGroupGuid === action.payload) {
          delete state[batchGuid];
        }
      }
    });
  },
});

export const { batchesLoaded } = batchesSlice.actions;
export const batches = batchesSlice.reducer;
